import { AddComment as AddComment_filmzi } from "./AddComment.filmzi";
import { AddComment as AddComment_kojaro } from "./AddComment.kojaro";
import { AddComment as AddComment_pedal } from "./AddComment.pedal";
import { AddComment as AddComment_zoomg } from "./AddComment.zoomg";
import { AddComment as AddComment_zoomit } from "./AddComment.zoomit";

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_TENANT) {
    case "filmzi":
      return AddComment_filmzi;

    case "kojaro":
      return AddComment_kojaro;

    case "pedal":
      return AddComment_pedal;

    case "zoomg":
      return AddComment_zoomg;

    default:
      return AddComment_zoomit;
  }
};

export const AddComment = IconRenderer();
